import { SET_BILLING_USAGE, CLEAR_BILLING_USAGE, SET_LAST_MONTH_BILLING_USAGE } from './billingUsageTypes';

const initialState = {
    currentBillingUsage: null,
    lastMonthBillingUsage: null,
};

export default function billingUsageReducer(state = initialState, action) {
    switch (action.type) {
        case SET_BILLING_USAGE:
            return { ...state, currentBillingUsage: action.payload };
        case SET_LAST_MONTH_BILLING_USAGE:
            return { ...state, lastMonthBillingUsage: action.payload };
        case CLEAR_BILLING_USAGE:
            return initialState;
        default:
            return state;
    }
}
